import { render, staticRenderFns } from "./my-integral.vue?vue&type=template&id=3b29ea1a&scoped=true&"
import script from "./my-integral.vue?vue&type=script&lang=js&"
export * from "./my-integral.vue?vue&type=script&lang=js&"
import style0 from "./my-integral.vue?vue&type=style&index=0&id=3b29ea1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29ea1a",
  null
  
)

component.options.__file = "my-integral.vue"
export default component.exports